module.exports = __webpack_public_path__ + "img/filter-icon.035386c4.svg";